var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoKwater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.153 12.4235C16.153 16.0548 13.2078 19 9.57648 19C5.9452 19 3 16.0548 3 12.4235C3 8.79225 6.76992 3.68748 8.60067 1.45859C9.10368 0.845375 10.0422 0.84893 10.5416 1.46392C12.3688 3.7177 16.1512 8.81536 16.1512 12.4218L16.153 12.4235Z",
    fill: "#33A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54248 10.2888C6.41628 10.2888 6.28653 10.2622 6.16389 10.2035C5.71953 9.99378 5.52935 9.46589 5.73731 9.02153C6.33452 7.75245 7.21257 6.28963 8.27903 4.78948C8.56342 4.38956 9.11797 4.29535 9.51789 4.57974C9.91782 4.86413 10.012 5.41869 9.72763 5.81861C8.72161 7.23344 7.89866 8.60206 7.34588 9.77694C7.1948 10.0987 6.87486 10.2871 6.5407 10.2871L6.54248 10.2888Z",
    fill: "#A6DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66972 13.3122C5.17915 13.3122 4.78101 12.9141 4.78101 12.4235C4.78101 12.2991 4.78634 12.1694 4.79878 12.0378C4.84322 11.549 5.27513 11.1882 5.76392 11.2309C6.25272 11.2753 6.61353 11.7072 6.5691 12.196C6.56199 12.276 6.55843 12.3524 6.55843 12.4235C6.55843 12.9141 6.16029 13.3122 5.66972 13.3122Z",
    fill: "#A6DBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.153,
    height: 18,
    fill: "white",
    transform: "translate(3 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoKwater);
export default __webpack_public_path__ + "static/media/ico-kwater.5230936cc3ade6f9d3bc5b674181ccb9.svg";
export { ForwardRef as ReactComponent };